import { APICore } from './apiCore'

const api = new APICore()

function getSeaLogs (params) {
  const baseUrl = '/sea-logs'
  return api.get(baseUrl, params)
}

function getSeaLog (id) {
  const baseUrl = `/sea-logs/${id}`
  return api.get(baseUrl, {})
}

function addSeaLog (params) {
  const baseUrl = '/sea-logs'
  return api.create(baseUrl, params)
}

function updateSeaLog (params) {
  const baseUrl = '/sea-logs'
  return api.update(baseUrl, params)
}

function deleteSeaLog (params) {
  const baseUrl = '/sea-logs'
  return api.delete(baseUrl, params)
}

export { getSeaLogs, getSeaLog, addSeaLog, updateSeaLog, deleteSeaLog }
